var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border":"1px solid #ccc","width":"100%","position":"relative","z-index":"100 !important"}},[_c('div',{ref:"editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }